module.exports = __webpack_public_path__ + "img/xuanzhong_y.39d8d252.svg";